export default "__VITE_ASSET__BXVB5Fyn__"